// extracted by mini-css-extract-plugin
module.exports = {"drawer":"ModalDrawerDialog_drawer__213k7","drawerContentWrapper":"ModalDrawerDialog_drawerContentWrapper__ySSfi","drawerCrossBtn":"ModalDrawerDialog_drawerCrossBtn__wzWBQ"};